import { observable, action, computed, flow } from 'mobx';
import Util from 'utils';
import React from 'react';
import Config from 'config/Config';
import Cookies from 'js-cookie';
import { toJS } from 'mobx';
import {
  countryList,
  xverseParams,
  appSecret_YX,
  appSecret_HLW,
  appSecret_FN,
  appSecret_GCC
} from 'utils/constants';
import { hex_md5 } from 'utils/md5';
import { Flex, Modal, Toast } from 'antd-mobile';

import { getWorkWechatAppId } from 'utils/wxUtils';
import Serv from './AppServ';
import { translation, Language_List } from 'config/language/context';
import { clearCardInfoCache } from 'utils/businessCard';
import { getRuntimeStore } from 'utils/runtimeStores';

let _reactDom = require('react-dom');

class AppMod {
  // 是否国际化版本
  // @observable isInternationalized = false;
  @observable isInternationalized =
    [
      'cxwygj.com',
      'h5.cxwygj.com',
      'intl.yofogo.com',
      'foreign.yofogo.com',
      'intl.fanxinggj.com',
      'foreign.fanxinggj.com',
      'foreignh5.uat3.yofoys.cn'
    ].includes(location.host) ||
    location.hash.indexOf('isInter') != -1 ||
    localStorage.getItem('isInter') ||
    (localStorage.getItem('lng') || 'cn') != 'cn';
  // 登录后返回的token，可以用来判断是否已经登录
  @observable token = null;

  @observable opertionQuery = {
    0: '服务体验',
    1: '发货中订单',
    2: '已完成订单',
    3: '售后评价',
    4: '业绩评价',
    5: '打卡评价',
    6: '名片评价',
    7: '云店评价',
    8: '课程评价',
    9: '业务评价'
  };

  @observable serviceExperienceSurveyTagRespDtos = [];

  // 用户信息
  @observable userInfo = {};

  // 店铺信息
  @observable storeInfo = {};

  // 判断是否处于app环境
  @observable isApp = false;

  // 是否已绑定微信
  @observable isBindingWechat = false;

  // 微信相关信息
  @observable wxInfo = {};

  // 路由跳转次数
  @observable historyCount = 0;

  @observable collectIds = []; // 收藏产品id列表

  // 是否处于“我的”tab
  @observable isOnMineTab = false;

  // 判断是否是从 智能名片分享链接 进入
  @observable isSmartCard = {};

  // 判断是否从分享进入的H5
  @observable isCardCode = {};

  // 10个8则绑定此健康顾问
  @observable bindCardCode = {};

  // 判断学习培训48堂课广告是否展示
  @observable isShowPoster = true;

  // 判断精英课堂广告是否展示
  @observable isShowPosterTwo = true;

  // 路由权限点
  @observable authList = [];

  // 标签权限点
  @observable tagAuthList = [];

  // 搜索内容类型权限点
  @observable searchAuthList = [];

  @observable cardTypeNameSign = -1;

  @observable cardTypeName = '';

  @observable cardInfo = {};

  @observable titleName = '';

  // 站点的相关配置项-数据字典
  @observable systemConfig = {};

  // 是否已经检查过安全信息提示（提示去修改密码和上传身份证明照片）
  isCheckSafeTipsFlag = false;

  // 是否收集智能名片的信息（默认不收集， 访客和微信浏览器环境会收集，其他浏览器环境直接上报空信息）
  @observable smartCardSave = false;

  // 是否弹框售后服务总则
  showAfterPopupView = false;

  // 代客信息缓存
  dgInfo = {};

  // 是否弹过生日弹窗，只弹一次
  @observable isShowBirthdayModal = false;

  // 是否弹过生日弹窗，只弹一次
  @observable isShowBirthdayModal_Mine = false;

  // 全局JSON请求配置
  @observable globalAjaxJson = {};

  // 用户授权的信息
  hasWechatAuth = '';

  // 专题返回目标页面
  @observable fromHome = false;

  // 学习培训页面返回，是否返回到上一页
  @observable goBack = false;

  // 商学院信息
  @observable personalInfo = {};

  @observable showQuesModal = false;

  @observable showPayModalQuestion = false; // 支付页评价弹窗，是否弹过

  @observable associatedTradeNos = '';

  @observable tradeNo = '';

  @observable activeBankId = '';

  @observable birthdayInfo = {};

  @observable homePopupShow = false;

  // 首页弹窗是否已展示
  @observable myPopupShow = false;

  // 我的页面弹窗是否已展示
  @observable paySuccessOrderNo = '';

  // 记录当前支付完成的订单编号
  @observable exitPaymentOrderNo = ''; // 退出支付的订单号

  @observable autoSortNum = 999; // 1夏烨  2利剑  3德道  0不自动排网

  @observable popupPosition = '';

  // 记录弹窗位置
  // 证件类型中是否展示其它证件类型
  @observable showIdentityType4 = [];

  isFromAPP = false; // 是否为app的webview嵌套

  // 添加银行卡表单数据
  @observable bankCardForm = {};

  @observable onLineServiceUrl =
    'https://qiyukf.com/script/f5a2d07fcd2e3b1b63ee71412090db14.js?hidden=1'; // 在线客服地址

  // 展业图片配置
  @observable imgSolution = {};

  // 推荐商品是否显示 0：不显示 1：显示
  @observable recommendItemShow = 0;

  // 云健康白名单标识
  @observable healthShowStatus = false;

  @observable internationalConfig = {
    // 是否隐藏补充运费配置
    hideSupplementFreight: false,
    // 是否隐藏邮箱配置
    hideEmail: false,
    // 是否隐藏名族配置
    hideNation: false,
    // 是否隐藏邮政配置
    hidePostcode: false
  };

  constructor() {
    this.init();
  }

  @observable areaCode = `86`;

  @observable hasJointCreationTag = false;

  // 是否有联创店铺-审核通过
  @observable hasReviewJointCreationTag = false;

  // 国际短信初始值
  @action
  changeState(key, value) {
    this[key] = value;
  }

  @action
  changeStateObj(obj) {
    Object.keys(obj).forEach((e) => {
      this[e] = obj[e];
    });
  }

  /**
   * 初始化
   */
  @action
  init() {
    this.initQueryParams();
    this.token = Util.getLocalCache(Config.localStorageKeys.member_token);
    this.userInfo = Util.getLocalCache(Config.localStorageKeys.member_userInfo) || {};
    this.getUserInfo(false);
    this.getImgSolution();
    this.getHostJsonConfig();
    // this.getGoodsFor99microShop();

    if (this.token && this.userInfo) {
      this.getMyStoreList();
      this.getHealthShowStatus();
      this.getInternationalConfig();
    }
    const location = window.location;
    const { host } = location;
    if (['h5.xbailing.com'].includes(host)) {
      // XBL
      this.onLineServiceUrl =
        'https://qiyukf.com/script/e790d8cb5bbfb0fe94481c5391f90032.js?subdomain=1&hidden=1';
    }
    // 获取汇率
    this.fetchExchangeRate();
  }

  /**
   * 查询我的店铺信息 是个数组
   */
  getMyStoreList = flow(function* () {
    try {
      const { data } = yield Serv.queryMyStore();
      if (data) {
        if (data.length > 0) {
          const index = data.findIndex((item) => item.jointCreationTag == 1);
          const hasReviewJointCreationTag = data.findIndex(
            (item) => item.jointCreationTag == 1 && !!item.code
          );
          this.hasJointCreationTag = index != -1;

          this.hasReviewJointCreationTag = hasReviewJointCreationTag != -1;
        }
      }
    } catch (error) {
      console.log('error = ', error);
    }
  });

  /**
   * 初始化-参数处理
   */
  @action
  initQueryParams() {
    let locationHrefParams = window.location.href.split('?')[1];
    const sourceTypeParams =
      Util.getQueryString('sourceType') || Util.getQueryString('loginBackType');

    if (sourceTypeParams == 'xverse' || sourceTypeParams == 'back') {
      // 全局sourceType,目前以元宇宙为主
      Util.setLocalCache('sourceTypeParams', sourceTypeParams || '');
      if (locationHrefParams) {
        Util.setLocalCache('locationHrefParams', locationHrefParams || '');
      }
    }

    // 是否是app嵌套webView跳转商学院
    this.isFromAPP = Util.getQueryString('app') == 'true';
  }

  get workWechatAgentId() {
    // 当前是否通过企业微信打开H5
    const agentId = Util.getQueryString('agentId') || sessionStorage.getItem('agentId');
    return agentId;
  }

  /**
   * 校验免登录信息
   * @param {*} params
   * @returns {Boolean} true:免登录成功  false:免登录失败
   */
  @action
  checkFreeLogin(callback = function () {}) {
    const appId =
      Util.getParamsQueryString(document.location.href, 'appId') ||
      Util.getParamsQueryString(document.location.href, 'appid');
    const token = Util.getParamsQueryString(document.location.href, 'token') || ''; // token
    const time = Util.getParamsQueryString(document.location.href, 'time') || ''; // phone
    const sign = Util.getParamsQueryString(document.location.href, 'sign') || ''; // sign 验签内容全部转大写
    const r = Util.getParamsQueryString(document.location.href, 'r') || ''; // 跳转地址
    const auth_code = Util.getParamsQueryString(document.location.href, 'auth_code');
    const app_id = Util.getParamsQueryString(document.location.href, 'app_id');
    const source = Util.getParamsQueryString(document.location.href, 'source');
    const pstr = Util.getParamsQueryString(document.location.href, 'pstr');
    // alert("token && time && appId && sign 123" + token + ',' + time + ','  + appId + ','  + sign + 'r:' + r)
    // alert("auth_code && app_id" + auth_code + ',' + app_id + ',' + source);
    let appSecret = appSecret_YX;
    if (token && time && appId && sign) {
      // 免登录
      if (appId == '10716881') {
        // HLW 医院
        appSecret = appSecret_HLW;
      } else if (appId == '10987352') {
        // 蜂鸟
        appSecret = appSecret_FN;
      } else if (appId == '10980413') {
        // GCC
        appSecret = appSecret_GCC;
      } else if (appId == '10016880') {
        // 中台
      }
      Util.setLocalCache('member_appId', appId || '');
      // 常规免登录流程
      let checkSign = hex_md5(`${token}${time}${appId}-${appSecret}`).toUpperCase();
      if (checkSign == sign) {
        this.token = token || '';
        Util.setLocalCache(Config.localStorageKeys.member_token, token || '');
        this.init();
        if (source === 'alipay_wallet' && auth_code) {
          // window.app.routerRedirect(
          //   `/shop/alipayScheme?auth_code=${auth_code}&app_id=${app_id}&pstr=${pstr}`
          // );
          callback && callback(true);
          return true;
        }
        if (r) {
          // 有跳转地址
          window.app.routerRedirect(r);
        }
        callback && callback(true);
        return true;
      }
      callback && callback(false);
      return false;
    }
    callback && callback(false);
    return false;
  }

  /**
   * 元宇宙跳转
   */
  @action
  jumpVerse(isDetail = false) {
    // isDetail 商品详情
    const {
      cardAttribute,
      cardPwdStatus,
      memberStatus,
      belongSystem,
      contractSign,
      id,
      realName = '',
      phone = '',
      cardCode = ''
    } = this.userInfo || {};

    let sourceTypeParams = Util.getLocalCache('sourceTypeParams');
    let locationHrefParams = Util.getLocalCache('locationHrefParams') || '';
    let sourceXversePopup = Util.getLocalCache('sourceXversePopup') || '';
    let host = 'https://h5.xverse.cn/sansheng/index.html';
    if (Config.HOST != 'GREEN' && Config.HOST != 'PROD') {
      // 非生产
      host = 'https://uat-h5.xverse.cn/sansheng/dev/sansheng/index.html';
    }
    if (sourceTypeParams == 'xverse') {
      // 元宇宙
      localStorage.removeItem('sourceTypeParams');
      localStorage.removeItem('locationHrefParams');
      localStorage.removeItem('sourceXversePopup');

      let sign = hex_md5(
        `${id}${phone || ''}${cardCode || ''}${realName || ''}-${xverseParams}`
      ).toUpperCase();
      let url = `${host}?source=h5&userId=${id}&nickname=${
        realName || ''
      }&phone=${phone || ''}&cardCode=${cardCode || ''}&sign=${sign}${
        locationHrefParams ? `&${locationHrefParams}` : ''
      }`;
      window.location.href = url;
      // window.location.replace(url)
      return false;
    }
    if (isDetail && sourceXversePopup == 'xverse') {
      // 商品详情分开处理,因函数是放在了用户信息保存里面，防止刷新再次处理
      // 元宇宙
      localStorage.removeItem('sourceTypeParams');
      localStorage.removeItem('locationHrefParams');
      localStorage.removeItem('sourceXversePopup');

      let sign = hex_md5(
        `${id}${phone}${cardCode || ''}${realName || ''}-${xverseParams}`
      ).toUpperCase();
      let url = `${host}?source=h5&userId=${id}&nickname=${
        realName || ''
      }&phone=${phone || ''}&cardCode=${cardCode || ''}&sign=${sign}${
        locationHrefParams ? `&${locationHrefParams}` : ''
      }`;
      window.location.href = url;
      // window.location.replace(url)
      return false;
    }
    return true;
  }

  // 跳转微信静默登录
  @action
  async jumpWeChatLogin(scope) {
    // if (Util.isXM) {
    //   // 享脉处理
    //   this.jumpXMLogin();
    //   return;
    // }
    const redirectUrl = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}#/WechatBaseLoginAuth`
    );
    let appId = Config.wxAppId;
    if (this.workWechatAgentId) {
      appId = (await getWorkWechatAppId()) || Config.wxAppId;
    }

    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
      appId
    }&redirect_uri=${redirectUrl}&response_type=code&scope=${scope || 'snsapi_userinfo'}${
      this.workWechatAgentId ? `&agentid=${this.workWechatAgentId}` : ''
    }#wechat_redirect`;
    window.location.replace(url);
  }

  /**
   * 跳转享脉静默登录
   */
  @action
  jumpXMLogin() {
    const redirectUrl = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}#/WorkPrivateAuth`
    );
    let appId = 'xm98f5358b3d871cdf';
    let host = 'https://openweb.sharexm.com';
    if (!['GREEN', 'PROD'].includes(Config.HOST)) {
      appId = 'xm98f5358b3d871cdf'; // 非生产环境
      host = 'http://openweb.test2.sharexm.com';
    }
    if (
      [
        'cxwygj.com',
        'h5.cxwygj.com',
        'intl.yofogo.com',
        'foreign.yofogo.com',
        'h5.test.yofoys.cn',
        'intl.fanxinggj.com',
        'foreign.fanxinggj.com',
        'foreignh5.uat3.yofoys.cn'
      ].includes(location.host)
    ) {
      host = 'https://openweb.sharexm.com';
      appId = 'xme7b249e549819637'; // 生产测试一致，国际版
    }
    const url = `${host}/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&scope=snsapi_login`;
    window.location.replace(url);
  }

  /**
   * 保存登录后用户信息
   */
  @action
  saveLoginInfo(data = {}) {
    return new Promise((resolve, reject) => {
      if (data.token) {
        Util.setLocalCache(Config.localStorageKeys.member_token, data.token);
        this.token = data.token;
        this.isShowBirthdayModal = false;
        this.isShowBirthdayModal_Mine = false;
      }
      let resPromise = this.getUserInfo();
      Util.setLocalCache(Config.localStorageKeys.member_userInfo, data);
      // this.getEnterList();
      // this.getUserdistriBution()
      if (data.token && data) {
        this.init();
      }

      const inletTitle = sessionStorage.getItem('inletTitle');
      if (inletTitle) {
        // 微信绑定登录成功后，用户生命周期埋点
        let type = 2;
        const inletTitleType = sessionStorage.getItem('inletTitleType');
        if (inletTitleType) {
          sessionStorage.removeItem('inletTitleType');
          type = inletTitleType;
        }
        sessionStorage.removeItem('inletTitle');
        window.sensors.track('userlifeCycle', {
          information_title: inletTitle,
          type, // type 1,2,3,4 区分点击、登录、注册、下单
          channel: 'H5',
          userId: data.userId || '',
          cardCode: data.cardCode || ''
        });
      }

      setTimeout(() => {
        let jump = this.jumpVerse(resPromise);
        if (jump) {
          resolve(resPromise);
        }
      }, 1000);
      // resPromise.then(r=>{
      //   resolve(r)
      // })
    });
  }

  /**
   * 用户类型(1普客2会员3店铺5子账号)
   */
  @computed
  get showHideOrderAndPer() {
    const { distributionRatioList, orderLabelList } = this.userInfo || {};
    // const neworderLabelList = toJS(orderLabelList);
    const neworderLabelList =
      orderLabelList &&
      orderLabelList.filter((item) => {
        const { value } = item || {};
        if (value) {
          return item;
        }
      });
    if (Array.isArray(toJS(neworderLabelList)) && toJS(neworderLabelList).length === 1) {
      const newdistributionRatioList = distributionRatioList[`${neworderLabelList[0].value}`];
      const returnValue =
        newdistributionRatioList &&
        newdistributionRatioList.filter((item) => {
          const { value } = item || {};
          if (value != '-1') {
            return item;
          }
        });

      if (Array.isArray(returnValue) && returnValue.length === 1) {
        return true;
      }
    }
    return false;
  }

  /**
   * 用户类型(1普客2会员3店铺5子账号)
   */
  @computed
  get userType() {
    if (this.userInfo && this.userInfo.userType) {
      return Number(this.userInfo.userType);
    }
    return 1;
  }

  /**
   * 是否乐道站点，有单独做处理
   */
  @computed
  get isLD() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'LD') {
      return true;
    }
    return false;
  }

  /**
   * 是否乘星吻月站点，有单独做处理
   */
  @computed
  get isCXY() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'CXY') {
      return true;
    }
    return false;
  }

  /**
   * 是否老鹰站点，有单独做处理
   */
  @computed
  get isLY() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'LY') {
      return true;
    }
    return false;
  }

  /**
   * 是否德亿，有单独做处理
   */
  @computed
  get isXDE() {
    return this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'XDE';
  }

  /**
   * 是否三才站点，有单独做处理
   */
  @computed
  get isWY() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'WY') {
      return true;
    }
    return false;
  }

  @computed
  get selectMallCoinLabel() {
    return this.isLY ? '甄选积分' : this.isCXY ? '豆豆积分' : '甄选积分' || '';
  }

  get selectMallCoinTitle() {
    return this.isLY ? '甄选积分' : this.isCXY ? '豆豆积分' : '可用积分' || '';
  }

  /**
   * 是否老鹰站点，有单独做处理
   */
  @computed
  get isTH() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'TH') {
      return true;
    }
    return false;
  }

  /**
   * 是否5A联盟体系下用户
   */
  @computed
  get isWLM() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'WLM') {
      return true;
    }
    return false;
  }

  /**
   * 是否为赋百龄
   */
  @computed
  get isXBL() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'XBL') {
      return true;
    }
    return false;
  }

  /**
   * 是否极萃体系下用户
   */
  @computed
  get isJCH() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'JCH') {
      return true;
    }
    return false;
  }

  /**
   * 是否合和站点
   */
  @computed
  get isHEH() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'HEH') {
      return true;
    }
    return false;
  }

  /**
   * 是否员工内购站点，有单独做处理
   */
  @computed
  get isStaff() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'SS') {
      return true;
    }
    return false;
  }

  @computed
  get isDD() {
    if (
      this.userInfo &&
      this.userInfo.belongSystem &&
      this.userInfo.belongSystem === 'DD' &&
      this.userInfo.userType !== 3 &&
      this.userInfo.userType !== 5
    ) {
      return true;
    }
    return false;
  }

  /**
   * 是否 DD 站点
   */
  @computed
  get isDDSystem() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'DD') {
      return true;
    }
    return false;
  }

  /**
   * 是否团队参加分享参数 fromTeamShareFlag
   */
  @computed
  get isTeamShareFlag() {
    if (
      this.userInfo &&
      this.userInfo.belongSystem &&
      ['DD', 'LJ'].includes(this.userInfo.belongSystem)
    ) {
      return true;
    }
    return false;
  }

  @computed
  get isHiddenShop() {
    // 是否隐藏店铺 店长字段
    return this.userInfo && this.userInfo.wordConvert == 0;
  }

  @computed
  get isHiddenShopLocal() {
    // 是否隐藏店铺 店长字段
    return false;
  }

  // 是否是三生站点
  @computed
  get isCompanySystem() {
    if (this.userInfo && this.userInfo.systemType == 0) {
      return true;
    }
    return false;
  }

  /**
   * 是否维多益站点，有单独做处理
   */
  @computed
  get isWDY() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'WDY') {
      return true;
    }
    return false;
  }

  /**
   * 是否东芝草站点，有单独做处理
   */
  @computed
  get isDZC() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'DZC') {
      return true;
    }
    return false;
  }

  /**
   * 是否为固定的卡号需隐藏功能
   */
  @computed
  get isHiddenCardCode() {
    let hiddenCardCodeList = ['68989835', 'ZS400511', 'ZS400336', 'YY021996'];

    return hiddenCardCodeList.includes(this.userInfo.cardCode);
  }

  /**
   *
   */
  @computed
  get isBelongCom() {
    if (
      (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'GONGSI') ||
      this.userInfo.belongSystem === 'ALL'
    ) {
      return true;
    }
    return false;
  }

  /**
   * 是否HSH站点，有单独做处理
   */
  @computed
  get isHSH() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'HSH') {
      return true;
    }
    return false;
  }

  /**
   * 是否KER站点，有单独做处理
   */
  @computed
  get isKER() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'KER') {
      return true;
    }
    return false;
  }

  /**
   * 是否XCH站点，有单独做处理
   */
  @computed
  get isXCH() {
    if (this.userInfo && this.userInfo.belongSystem && this.userInfo.belongSystem === 'XCH') {
      return true;
    }
    return false;
  }

  @computed
  get getLYStr() {
    //申请 开卡、升级(@黄军) 文字调整为申请开店 副文案调整为开店会员尊享权益
    return this.isLY ? '注册' : '开店';
    // : `${
    //     Stores.AppMod.userInfo && Stores.AppMod.userInfo.memberRetail
    //       ? openCardTextLess
    //       : oldOpenCardText
    //   }`;
  }

  @computed
  get isPlus() {
    const { whetherPlusMember } = this.personalInfo || {};
    return whetherPlusMember === 1;
  }

  @computed
  get isShowQuestionnaire() {
    return this.userInfo.serviceExperienceSurveyTag != 0;
  }

  isSatisfiedList(type) {
    let list = (this.serviceExperienceSurveyTagRespDtos || []).filter((item) => item.type == type);
    return list[0] || [];
  }

  /**
   * 汇率信息存储对象 - 对应币种汇率数据
   * {
   *   "belongCountry": null,       // 所属国家编号
   *   "belongCountryName": null,   // 所属国家名称
   *   "currencyCode": "CHY",       // 货币编码
   *   "currencyName": "人民币",    // 货币名称）
   *   "currencySymbol": "¥",       // 货币符号（如¥、$、€）
   *   "exchangeRate": 1            // 汇率值（
   * }
   * @type {Object} 单币种汇率信息对象
   */
  @observable exchangeRates = {};

  /**
   * 获取当前语言的汇率
   */
  @computed get currentExchangeRate() {
    const rateInfo = this.exchangeRates;
    return rateInfo ? rateInfo.exchangeRate : 1;
  }

  /**
   * 获取当前语言的货币符号
   */
  @computed get currencySymbol() {
    const rateInfo = this.exchangeRates;
    return rateInfo ? rateInfo.currencySymbol : '￥';
  }
  /**
   * 获取当前语言的货币名称
   */
  @computed get currencyName() {
    const rateInfo = this.exchangeRates;
    return rateInfo ? rateInfo.currencyName : '元';
  }
  /**
   * 获取当前语言的货币CODE
   */
  @computed get currencyCode() {
    const rateInfo = this.exchangeRates;
    return rateInfo ? rateInfo.currencyCode : 'CHY';
  }

  /**
   * 获取汇率映射表
   */
  fetchExchangeRate = flow(function* () {
    const { belongSystem } = this.userInfo || {};
    const params = {
      belongSystem: belongSystem || sessionStorage.getItem('systemCode') || ''
    };
    try {
      const { data, resultCode } = yield Serv.getExchangeRate(params);
      if (resultCode === '0' && data) {
        this.exchangeRates = data || {};
      }
    } catch (error) {
      console.log(error);
    }
  });

  guidelines = flow(function* (id) {
    try {
      const { data } = yield Serv.guidelines(id);
      return data;
    } catch (error) {}
  });

  guidelinesList = flow(function* (params) {
    try {
      const { data } = yield Serv.guidelinesList(params);
      return data;
    } catch (error) {}
  });

  getDefaultAreaCode() {
    if (this.isInternationalized) {
      const item = Language_List.find((item) => item.value === localStorage.getItem('lng')) || {};
      return item.areaCode || 1;
    }
    return '';
  }

  /**
   * 获取当前应该置顶/默认选中的国际区号标识 (code2 或 code)
   * 优先级:
   * 1. 优先检查用户所在国家(national)，若为美加俄哈等存在区号重复的国家，直接返回用户信息当前的national缩写(如'US')
   * 2. 其次使用用户的注册区号(areaCode)
   * 3. 若以上都无，根据当前语言环境(lng)从 Language_List 中获取默认区号
   * 4. 国际版兜底返回 1，非国际版兜底返回 '86'
   *
   * @param {Object} item 当前语言环境对象
   * @returns {String|Number} 区号标识 (例如: 'US', '86', 1)
   */
  getMatchedDefaultAreaCode(item) {
    // 存在区号重复、必须使用 national 缩写(code2)作为唯一标识的国家
    const uniqueNationalCodes = ['US', 'CA', 'RU', 'KZ']; // 美加俄哈

    // 1. 如果 userInfo.national 在必须使用缩写的列表中，直接返回该缩写
    if (this.userInfo.national && uniqueNationalCodes.includes(this.userInfo.national)) {
      return this.userInfo.national;
    }

    // 2. 如果存在普通的用户区号，则使用用户区号
    if (this.userInfo.areaCode) {
      return this.userInfo.areaCode;
    }

    // 3 & 4. 根据国际化环境及语言列表兜底
    if (this.isInternationalized) {
      return item.areaCode || 1;
    }

    return '86';
  }

  internationalJson = flow(function* () {
    let json = countryList
      .slice()
      .sort((a, b) => a.code - b.code)
      .map(async (item) => {
        const translated = await translation(item.areaName);

        return {
          ...item,
          value: item.code2 || item.code, // 使用唯一的 code2 解决美加、俄哈区号重复问题
          label: `+${item.code}(${translated})`
        };
      });

    json = yield Promise.all(json);
    // 国际版置顶默认区号
    if (this.isInternationalized) {
      const item = Language_List.find((item) => item.value === localStorage.getItem('lng')) || {};

      // 优先使用national国家代码，因为countryList的value默认使用是code2
      const areaCode = this.getMatchedDefaultAreaCode(item);

      const defaultAreaCodeIndex = (json || []).findIndex(
        (item) => item.value == areaCode || item.code == areaCode || item.code2 == areaCode
      );
      const copyItemJson = new Array(...json);
      // 繁体中文 置顶香港、台湾、澳门
      if (item.value === 'zh-tw') {
        const arr = [];
        const filterJson = json.filter((item) => {
          if (item.value !== '852' && item.value !== '853' && item.value !== '886') {
            return true;
          } else {
            arr.push(item);
            return false;
          }
        });
        json = [...arr, ...filterJson];
      } else if (defaultAreaCodeIndex >= 0) {
        copyItemJson.splice(defaultAreaCodeIndex, 1);
        json = [json[defaultAreaCodeIndex], ...copyItemJson];
      }
    }
    const systemCode = Util.getQueryString('systemCode') || sessionStorage.getItem('systemCode');
    let globalSms = localStorage.getItem('globalSms');
    const isLY =
      (window.document.location.href.indexOf('sbnh5') != -1 ||
        window.document.location.href.indexOf('nblcdz.cn') != -1 ||
        window.document.location.href.indexOf('sanshengjk.cn') != -1) &&
      globalSms != 'false';
    const isTH = systemCode === 'TH';
    return isLY || isTH || this.isInternationalized ? json : [countryList[0]];
  });

  /**
   * 获取个人信息
   */
  getLearnPersonalInfo = flow(function* () {
    try {
      const { data } = yield Serv.getLearnPersonalInfo();
      this.personalInfo = data || {};
    } catch (error) {}
  });

  getSatisfiedInfo = flow(function* (type) {
    try {
      const { data, resultCode } = yield Serv.getSatisfiedInfo(type);

      if (data == true) {
        this.showQuesModal = true;
      }
      return data;
      // this.personalInfo = data || {}
    } catch (error) {
      return false;
    }
  });

  updataOpertion = flow(function* (type) {
    try {
      const { data, resultCode } = yield Serv.updataOpertion(type);
      return resultCode;

      // this.personalInfo = data || {}
    } catch (error) {}
  });

  getCardCodeInfo = flow(function* (cardCode) {
    const { data } = yield Serv.getCardCodeInfo(cardCode);
    // console.log(data);
    // mobx失效了，不知道咋回事， 用promise吧
    this.cardInfo = data || {};
    // return data;
  });

  clickZan = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.clickZan(params);
      if (`${resultCode}` === '0') {
        return resultCode;
      }
    } catch (error) {}
  });

  getQuestionnaireList = flow(function* () {
    try {
      const { data } = yield Serv.getQuestionnaireList();
      this.serviceExperienceSurveyTagRespDtos = data;
    } catch (err) {}
  });

  /**
   * 获取权限点
   */
  getEnterList = flow(function* () {
    try {
      const { data: authData } = yield Serv.getEnterList();

      if (authData) {
        // 1-展业 2-我的 3-有享助手
        for (let key in authData) {
          const data = authData[key];
          data.forEach((item) => {
            // enterType: 1-路由，2-标签
            if (item.enterType === 1) {
              this.authList.push(item.routeKey);
            }

            if (item.enterType === 2) {
              this.tagAuthList.push(item.routeKey);
            }

            if (item.type === 8) {
              this.searchAuthList.push(item.routeKey);
            }
          });
        }
      }
      // personalList.forEach((item) => {
      //   //enterType: 1-路由，2-标签
      //   if(item.enterType === 1){
      //     this.authList.push(item.routeKey);
      //   }

      //   if(item.enterType === 2){
      //     this.tagAuthList.push(item.routeKey);
      //   }

      // })

      // expandList.forEach((item)=>{
      //   //enterType: 1-路由，2-标签
      //   if(item.enterType === 1){
      //     this.authList.push(item.routeKey);
      //   }

      //   if(item.enterType === 2){
      //     this.tagAuthList.push(item.routeKey);
      //   }
      // })
    } catch (err) {}
  });

  getSystemConfig = flow(function* (system) {
    try {
      const data = yield Serv.getSystemConfig(system);
      if (data) {
        this.systemConfig = data || {};
      }
    } catch (err) {}
  });

  checkGoto = flow(function* (id) {
    try {
      const data = yield Serv.checkGoto({ questId: id });
      if (data) {
        return data || {};
      }
    } catch (err) {}
  });

  getHostJsonConfig = flow(function* () {
    try {
      const data = yield Serv.getHostJsonConfig();
      if (data) {
        this.globalAjaxJson = data || {};
      }
      return data;
    } catch (err) {
      console.log('errr', err);
    }
  });

  @action
  getGiftWarehouseConfig = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.getWarehouseConfig();
      // const resData = {
      //   GIFT_STORAGE: {
      //     basic: {
      //       name: '礼仓订单', // 确认订单页面-收货方式
      //       name1: '礼品仓入口', // 我的页面入口按钮、进入云仓页面顶部title
      //       name2: '提货分享', // 云仓页面-剩余库存tab-右下角按钮
      //       name3: '赠送提货', // 云仓页面-第二个tab名称 点击详情进入页面的title
      //       name4: '提货赠送记录详情', // 第二个tab下记录的详情按钮名称
      //       name5: '请您提货', // 分享卡片名称
      //       name6: '我的提货列表', // 点击分享卡片进入页面的title h5
      //       content: '加入礼品仓后需要在XX月内完成提货，预期将根据以下地址自动发货' // 确认订单页面-选择个人礼品仓-下方显示提示文案
      //     },
      //     orderConditions: [
      //       {
      //         orderTypes: 1, // 1 零售 2 月复消 3 开卡 4 升级
      //         allocateCargoScale: '1', // 对应配货比例
      //         minAmount: 8.01,
      //         maxAmount: 8.02,
      //         bundleProductJoinType: 1,
      //         limitMinutes: 80000 // 分换月
      //       },
      //       {
      //         orderTypes: 1,
      //         allocateCargoScale: '2',
      //         minAmount: 8.01,
      //         maxAmount: 8.02,
      //         bundleProductJoinType: 1,
      //         limitMinutes: 120000
      //       }
      //     ],
      //     deliveryType: 1, // 出货方式 0 不指定(分享老逻辑) 1 指定不必填(不填分享老逻辑) 2 指定 必填
      //     syncJCConfig: {
      //       inOrder: 1,
      //       outOrder: 0
      //     }
      //   },
      //   NEW_CLOUD_STORAGE: {
      //     basic: {
      //       name: '薇美订单', // 确认订单页面-收货方式
      //       name1: '薇美云仓', // 我的页面入口按钮、进入云仓页面顶部title
      //       name2: '微提货分享', // 云仓页面-剩余库存tab-右下角按钮
      //       name3: '微赠送提货', // 云仓页面-第二个tab名称 点击详情进入页面的title
      //       name4: '微提货赠送记录详情', // 第二个tab下记录的详情按钮名称
      //       name5: '微请您提货', // 分享卡片名称
      //       name6: '微我的提货列表', // 点击分享卡片进入页面的title h5
      //       content: '加入薇美云仓后需要在XX月内完成提货，预期将根据以下地址自动发货' // 确认订单页面-选择个人礼品仓-下方显示提示文案
      //     },
      //     orderConditions: [
      //       {
      //         orderTypes: 1, // 1 零售 2 月复消 3 开卡 4 升级
      //         allocateCargoScale: '1', // 对应配货比例
      //         minAmount: 8.01,
      //         maxAmount: 8.02,
      //         bundleProductJoinType: 1,
      //         limitMinutes: 230000 // 分换月
      //       },
      //       {
      //         orderTypes: 1,
      //         allocateCargoScale: '2',
      //         minAmount: 8.01,
      //         maxAmount: 8.02,
      //         bundleProductJoinType: 1,
      //         limitMinutes: 520000
      //       }
      //     ],
      //     deliveryType: 1, // 出货方式 0 不指定(分享老逻辑) 1 指定不必填(不填分享老逻辑) 2 指定 必填
      //     syncJCConfig: {
      //       inOrder: 1,
      //       outOrder: 0
      //     }
      //   }
      // };
      let giftWarehouseConfig = {};
      let newWarehouseConfig = {};
      if (resultCode == '0' && data) {
        const resData = JSON.parse(data || '{}');
        giftWarehouseConfig = resData.GIFT_STORAGE || {};
        newWarehouseConfig = resData.NEW_CLOUD_STORAGE || {};
      }

      return { giftWarehouseConfig, newWarehouseConfig };
    } catch (err) {
      return {};
    }
  });

  // 查询个体户认证状态
  queryCertificationStatus = flow(function* () {
    try {
      const { data } = yield Serv.queryCertificationStatus();
      return data || 0;
    } catch (err) {
      console.log('queryCertificationStatus errr', err);
    }
  });

  /**
   * 获取用户信息
   * @param  {Boolean} ignore401  是否提示 401
   * @param  {Boolean} reqOthers  是否请求其他
   * @param {String} tradeNo  交易订单号
   */
  getUserInfo = flow(function* (ignore401 = true, reqOthers = true, tradeNo = '') {
    if (!this.token) {
      return [];
    }
    try {
      if (localStorage.getItem('isWeakPwd') == 1) {
        // 弱密码
        window.app.routerGoTo('/personal/account/alterPassword');
        return;
      }
      const { data } = yield Serv.getUserInfo(ignore401);
      if (data && data.national && ['US', 'CA', 'RU', 'KZ'].includes(data.national)) {
        this.changeState('areaCode', data.national);
        data.areaCode = data.national;
      } else {
        this.changeState('areaCode', data.areaCode);
      }
      Object.assign(this.userInfo, data);
      Util.setLocalCache(
        Config.localStorageKeys.member_userInfo,
        Object.assign(this.userInfo, data)
      );
      // 满足条件：1.绑定的健康顾问为10个8；2.自身会员卡号非test或TEST开头 3.自身为三生站点
      if (
        this.userInfo.healthConsultantNum &&
        this.userInfo.healthConsultantNum == '8888888888' &&
        // this.userInfo.cardCode &&
        !(
          this.userInfo.cardCode.substr(0, 4) == 'test' ||
          this.userInfo.cardCode.substr(0, 4) == 'TEST'
        ) &&
        this.userInfo.systemType != 1
      ) {
        const cardCode = this.bindCardCode.cardCode || this.isCardCode.cardCode || null;
        if (cardCode) {
          console.log('需要改健康顾问');
          const Data = yield Serv.setUpdateHealth(cardCode);
        }
      }

      // 神策埋点-保存用户
      console.warn('saveInfo', data);
      window.sensors.login(`${data.id || ''}`);
      // window.sensors.registerPage({
      window.sensors.registerPage({
        $user_id: data.id,
        cardCode: data.cardCode,
        realName: data.realName,
        userName: data.userName,
        shopNo: data.shopNo,
        userType: data.userType,
        client: 'H5'
      });
      // this.getGiftWarehouseConfig();
      // this.queryCertificationStatus();
      // 获取配货比例
      reqOthers && this.getUserdistriBution();
      reqOthers && data.userType * 1 !== 5 && this.getDiscountList();
      // 获取权限点
      if (reqOthers) {
        yield this.getEnterList();
      }

      reqOthers &&
        this.queryIdentityType4({
          cardCode: data.cardCode || data.healthConsultantNum
        });
      reqOthers && this.getQuestionnaireList();
      // 获取站点配置数据字典
      this.getSystemConfig(data.belongSystem);
      // 用户为店铺(或者子账号)身份，则查询店铺信息
      if ([3, 5].includes(+data.userType)) {
        const { data } = yield Serv.getStoreInfo(tradeNo);
        this.storeInfo = data || {};
      }

      // 获取99微购
      // this.getGoodsFor99microShop();

      return [this.userInfo, this.storeInfo];
    } catch (error) {
      return [];
    }
  });

  /**
   * 获取个人中心用户信息
   */
  getPersonalInfo = flow(function* () {
    if (!this.token) {
      return;
    }
    try {
      const { data } = yield Serv.getPersonalInfo();
      console.log('用户信息', toJS(data));
      this.userInfo = {
        ...this.userInfo,
        ...data,
        ...(data.cardCode
          ? {}
          : {
              cardCode: this.userInfo.cardCode
            })
      };
      Util.setLocalCache(Config.localStorageKeys.member_userInfo, this.userInfo);
    } catch (error) {}
  });

  /**
   * 获取展业图片配置
   *
   * @memberof PromoteHomeMod
   */
  getImgSolution = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getImgSolution();

      if (resultCode === '0') {
        this.imgSolution = data;
      }
    } catch (err) {
      console.log('失败', err);
    }
  });

  /**
   * 可儿玫瑰更新健康顾问
   */
  setKerUpdateHealth = flow(function* () {
    if (!this.token) {
      return;
    }
    try {
      const { belongSystem } = this.userInfo || {};

      if (belongSystem == 'KER') {
        // 可儿玫瑰更新健康顾问
        const { cardCode = null } = this.isCardCode;

        if (cardCode && cardCode != '') {
          // 分享进入
          const kerData = yield Serv.setKerUpdateHealth(cardCode);
        }
      }
    } catch (error) {}
  });

  /**
   * 根据健康顾问获取站点配置显示卡类型还是卡类型名称
   */
  getCardTypeName = flow(function* (healthyCode) {
    try {
      const { data } = yield Serv.getCardTypeName(healthyCode);
      const { cardLevelNameType, cardTypeName } = data || {};
      this.cardTypeNameSign = cardLevelNameType;
      this.cardTypeName = cardTypeName;
    } catch (error) {}
  });

  /**
   * 获取用户支持的配货比例，存入userInfo
   */
  getUserdistriBution = flow(function* () {
    if (!this.token) {
      return;
    }
    try {
      let { data } = yield Serv.getUserdistriBution({
        orderType: 1
      });
      // let distributionRatioList = [];
      let obj = {};
      let defaultItem = {
        label: '未选择',
        orderMinAmount: 0,
        value: '-1'
      };
      if (this.isLY) {
        // 老鹰站点，购物车、快速购物、商品详情 配货比例只显示1：1
        data = data.filter((item) => item.orderProperty === '1');
      }
      let handleDistriBution = (data) => {
        let distMap = [];
        if (data && data.length > 0) {
          // 按从小到大排序
          // for (let i = 0; i < data.length - 1; i++) {
          //   for (let j = 0; j < data.length - 1 - i; j++) {
          //     if (+data[j].orderProperty > +data[j + 1].orderProperty) {
          //       [data[j], data[j + 1]] = [data[j + 1], data[j]];
          //     }
          //   }
          // }

          distMap = data.map((item) => {
            const { orderProperty, orderPropertyName, aliasName, orderMinAmount, orderMinBv } =
              item;

            return {
              value: orderProperty,
              // label: `${orderPropertyName} 配货`,
              label: `${aliasName}`,
              orderMinAmount,
              orderMinBv
            };
          });
        }
        return distMap;
      };
      obj['1'] = [...handleDistriBution(data)];
      let { data: data2 } = yield Serv.getUserdistriBution({
        orderType: 2
      });
      if (this.isLY) {
        // 老鹰站点，购物车、快速购物、商品详情 配货比例只显示1：1
        data2 = data2.filter((item) => item.orderProperty === '1');
      }
      obj['2'] = [...handleDistriBution(data2)];
      this.userInfo = {
        ...this.userInfo,
        distributionRatioList: obj
      };
      Util.setLocalCache(Config.localStorageKeys.member_userInfo, this.userInfo);
    } catch (error) {}
  });

  /**
   * 获取折扣信息
   */
  getDiscountList = flow(function* (memberCard) {
    try {
      let params = {
        orderType: 1
      };
      console.log('memberCard', memberCard);
      if (this.userInfo.userName) {
        if (memberCard) {
          params.shopCode = this.userInfo.userName;
        } else {
          params.shopCode = '';
        }
      }
      if (memberCard) {
        params.dgCardCode = memberCard;
        params.dgStatus = 1;
      }
      let obj = {};
      let defaultItem = {
        label: '全价',
        orderMinAmount: 0,
        orderMinBv: 0,
        value: 1
      };
      let handleDiscountMap = (data) => {
        let distMap = [];
        if (data && data.length > 0) {
          // 按从小到大排序
          for (let i = 0; i < data.length - 1; i++) {
            for (let j = 0; j < data.length - 1 - i; j++) {
              if (+data[j].orderDiscount > +data[j + 1].orderDiscount) {
                [data[j], data[j + 1]] = [data[j + 1], data[j]];
              }
            }
          }

          distMap = data.map((item) => {
            const { orderDiscount, orderDiscountExplain, orderMinAmount, orderMinBv } = item;

            return {
              value: orderDiscount,
              label: `${orderDiscountExplain}折`,
              orderMinAmount,
              orderMinBv
            };
          });
        }
        return distMap;
      };

      const { data } = yield Serv.getDiscountList(params);
      if (data.dataType == 1) {
        obj['1'] = [...handleDiscountMap(data.lstDiscount), defaultItem];
      }

      let params_2 = {
        orderType: 2
      };
      if (this.userInfo.userName) {
        if (memberCard) {
          params_2.shopCode = this.userInfo.userName;
        } else {
          params_2.shopCode = '';
        }
      }
      if (memberCard) {
        params_2.dgCardCode = memberCard;
        params_2.dgStatus = 1;
      }
      const { data: data2 } = yield Serv.getDiscountList(params_2);
      if (data2.dataType == 1) {
        obj['2'] = [...handleDiscountMap(data2.lstDiscount), defaultItem];
      }

      // orderVersion=1 是新零售
      this.userInfo = {
        ...this.userInfo,
        discountList: obj,
        orderVersion: data2.dataType
      };
      Util.setLocalCache(Config.localStorageKeys.member_userInfo, this.userInfo);
    } catch (error) {}
  });

  // 当前域名校验
  getCheckHostDomain = flow(function* (data) {
    return true;
    // const location = window.location;

    // if (location && this.globalAjaxJson) {
    //   const {host, hash, protocol} = location;
    //   if (
    //     this.globalAjaxJson.domainLIst &&
    //     this.globalAjaxJson.domainLIst.length > 0 &&
    //     location.host != 'localhost:8080' &&
    //     location.host != 'localhost:3002' &&
    //     location.host != 'h5.uat3.yofoys.cn' &&
    //     location.host != 'h5.uat3.nblcdz.cn' &&
    //     location.host != '10.13.0.150:3002'
    //   ) {
    //     // 取JSON列表
    //     let result = this.globalAjaxJson.domainLIst.some(item => item == host);
    //     console.log(result);
    //     if (!result) {
    //       // 域名不存在，跳转数组第1个域名
    //       let url = `${protocol}//${this.globalAjaxJson.domainLIst[0]}/${hash}`;
    //       console.log(url);
    //       window.location.replace(url);
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   } else {
    //     return true;
    //   }
    // } else {
    //   return true;
    // }
  });

  // 老鹰域名判断
  getCheckDomainTips = flow(function* (belongSystem) {
    // 视康其他渠道放开登录
    // if (belongSystem && belongSystem == 'LY') {
    //   const location = window.location;
    //   const {host} = location;
    //   if (
    //     host != 'h5.nblcdz.cn' &&
    //     host != 'sbnh5.uat.yofoys.cn' &&
    //     host != 'sbnh5.uat2.yofoys.cn' &&
    //     host != 'localhost:3002' &&
    //     host.indexOf('nblcdz.cn') == -1
    //   ) {
    //     // 老鹰站点
    //     window.app.routerGoTo('/login/CommonTips');
    //     return false;
    //   }
    //   return true;
    // }
    return true;
  });

  // 设置是否处于app环境
  @action
  setApp(isApp) {
    this.isApp = isApp;
  }

  // 记录路由跳转次数变化
  @action
  addHistory() {
    this.historyCount += 1;
  }

  @action
  minusHistory() {
    this.historyCount -= 1;
  }

  // 获取收藏产品id
  getCollectIds = flow(function* () {
    if (!this.token) {
      return;
    }
    try {
      const { data } = yield Serv.getCollectIds();
      this.collectIds = data || [];
    } catch (error) {}
  });

  // 清除当前用户信息（如退出登录的时候）
  @action
  clearData() {
    // 记住最近登录的6个账号不要清除
    const recentSixNum = Util.getLocalCache(Config.localStorageKeys.member_recentSixNum);
    let decoratorBackHref = localStorage.getItem('decoratorBackHref') || '';

    // 记住上次登录的手机号不要删除
    const loginLastPhoneNum = Util.getLocalCache(Config.localStorageKeys.login_lastPhoneNum) || '';
    // 路由跳转次数不要清除
    const routerCount = sessionStorage.getItem('routerCount');
    // 开卡的表单信息不要清除
    const cardFillMsg = Util.getLocalCache(Config.localStorageKeys.member_cardFillMsg);
    // 登录后是否回到上一个页面不要清除
    const loginGoback = Util.getLocalCache(Config.localStorageKeys.loginGoback);
    const bindCardCode = Util.getLocalCache('bindCardCode');
    const onlineAddress = Util.getLocalCache('onlineAddress');
    const onlineUserId = Util.getLocalCache('onlineUserId');
    // LY登录
    const lyCode = sessionStorage.getItem('systemCode');
    let cacheObj = {};
    if (lyCode == 'LY') {
      cacheObj = Util.getKeysLocalCache([
        'remberPwdForAccNum',
        'isRemberPwdForAcc',
        'remberPwdForPhoNum',
        'isRemberPwdForPho'
      ]);
    }
    const registerRoute = Util.getLocalCache('registerRoute');
    const fromTeamShareFlag = Util.getLocalCache('fromTeamShareFlag');

    const sourceTypeParams = Util.getLocalCache('sourceTypeParams');
    let share_link_Id = Util.getLocalCache(Config.localStorageKeys.share_link_Id);

    const supplementData = Util.getLocalCache('supplement_data') || {}; // 权益共享卡信息
    const member_appId = Util.getLocalCache('member_appId') || ''; // 来源用户APPID，三方使用
    const lng_config = localStorage.getItem('lng') || 'cn'; // 语言配置
    const country_config = localStorage.getItem('country'); // 国籍配置
    localStorage.clear();
    supplementData && Util.setLocalCache('supplement_data', supplementData);
    fromTeamShareFlag && Util.setLocalCache('fromTeamShareFlag', fromTeamShareFlag);
    share_link_Id && Util.setLocalCache(Config.localStorageKeys.share_link_Id, share_link_Id); // shareId 全局分享参数
    const fromOrigin = sessionStorage.getItem('fromOrigin');
    const agentId = sessionStorage.getItem('agentId');
    sessionStorage.clear();
    // 网址来源 不会因为登录而请除
    fromOrigin && sessionStorage.setItem('fromOrigin', fromOrigin);
    agentId && sessionStorage.setItem('agentId', agentId);
    Cookies.remove(Config.localStorageKeys.member_userInfo);
    sourceTypeParams && Util.setLocalCache('sourceTypeParams', sourceTypeParams);
    member_appId && Util.setLocalCache('member_appId', member_appId);
    lng_config && localStorage.setItem('lng', lng_config);
    country_config && localStorage.setItem('country', country_config);
    this.token = null;
    this.userInfo = {};
    this.storeInfo = {};
    this.isApp = false;
    this.isBindingWechat = false;
    this.wxInfo = {};
    this.historyCount = 0;
    this.giftPackage = [];
    this.collectIds = [];
    this.authList = [];
    this.tagAuthList = [];
    this.birthdayInfo = {};

    // 清空购物车数据
    const ShoppingCartMod = getRuntimeStore('ShoppingCartMod');
    // 假如这时候取不到ShoppingCartMod也不用去清ShoppingCartMod中的状态
    ShoppingCartMod && ShoppingCartMod.clearData();
    const BusinessCardMod = getRuntimeStore('BusinessCardMod');
    // 假如这时候取不到BusinessCardMod也不用去清BusinessCardMod中的状态
    BusinessCardMod && BusinessCardMod.clearData();
    // 清除名片缓存（使用新的 Hook）
    clearCardInfoCache();

    Util.setLocalCache(Config.localStorageKeys.member_recentSixNum, recentSixNum);
    Util.setLocalCache(Config.localStorageKeys.login_lastPhoneNum, loginLastPhoneNum);
    lyCode && Util.setKeysLocalCache(cacheObj);
    Util.setLocalCache(Config.localStorageKeys.member_cardFillMsg, cardFillMsg);
    Util.setLocalCache(Config.localStorageKeys.loginGoback, loginGoback);
    Util.setLocalCache('registerRoute', registerRoute);
    Util.setLocalCache('bindCardCode', bindCardCode);
    // localStorage.setItem('decoratorBackHref', decoratorBackHref);
    routerCount && sessionStorage.setItem('routerCount', routerCount);
    lyCode && sessionStorage.setItem('systemCode', lyCode);
    if (onlineAddress === '1') {
      Util.setLocalCache('onlineAddress', onlineAddress);
      Util.setLocalCache('onlineUserId', onlineUserId);
    }
    // 清空是否检查过安全提示弹窗的标识（提示去修改密码和上传身份证明照片）
    this.isCheckSafeTipsFlag = false;
    this.internationalConfig = {
      // 是否隐藏补充运费配置
      hideSupplementFreight: false,
      // 是否隐藏邮箱配置
      hideEmail: false,
      // 是否隐藏名族配置
      hideNation: false,
      // 是否隐藏邮政配置
      hidePostcode: false
    };
  }

  // 解密敏感信息
  getDecyptMsg = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.getDecyptMsg(params);
      if (resultCode == 0) {
        return data;
      }
      return '';
    } catch (err) {
      return '';
    }
  });

  // 获取重大信息配置
  getMajorEvents = flow(function* (params) {
    const { data } = yield Serv.getMajorEvents(params);
    if (data == 1) {
      document.getElementsByTagName('html')[0].style.filter = 'grayscale(100%)';
    }
  });

  /**
   * 获取内容提醒消费VIP相关配置
   */
  queryVipReminderForFront = flow(function* () {
    const result = yield Serv.queryVipReminderForFront();
    return result;
  });

  /**
   * 获取累计金额
   */
  getPaymentAmount = flow(function* (params) {
    try {
      const result = yield Serv.getPaymentAmount(params);
      return result;
    } catch (error) {}
  });

  // 邀请埋点
  injectVistor = flow(function* ({ shareContentId, shareId, type }) {
    try {
      const { data } = yield Serv.injectVistor({
        source: 1,
        type,
        shareContentId,
        sourceId: shareId
      });
      console.log(data, 'dddd');
      return data || {};
    } catch (err) {
      console.log('errrr', err);
    }
  });

  // 获取分享自动排网
  getAutoSortResult = flow(function* () {
    console.log('abcde213');
    try {
      // if(this.autoSortNum == 999){
      const { data } = yield Serv.getAutoSortResult();
      this.autoSortNum = data || 0;
      // }

      return this.autoSortNum || {};
    } catch (err) {
      this.autoSortNum = 0;
    }
  });

  // 获取培训方案配置
  queryProjectDetail = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.queryProjectDetail();
      if (resultCode === '0') {
        return data;
      }
    } catch (error) {}
  });

  /**
   * 根据卡号获取证件类型中其它类型是否显示标识
   * 1 展示 0 不展示
   *
   */
  queryIdentityType4 = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.queryIdentityType4(params);
      if (resultCode === '0') {
        this.showIdentityType4 = !!data;
      }
    } catch (error) {}
  });

  queryIdentityType4V2 = flow(function* (cardCode) {
    try {
      const { resultCode, data } = yield Serv.queryIdentityType4({
        cardCode
      });
      let certTypeList = [
        { label: '身份证', value: 1 },
        { label: '护照', value: 2 },
        { label: '港澳台证', value: 3 },
        { label: '其它证件', value: 4 }
      ];
      if (resultCode === '0') {
        // 其它证件类型禁用的站点编号列表
        if (data === 0) {
          certTypeList = [{ label: '身份证', value: 1 }];
        }
      }
      return certTypeList;
    } catch (error) {}
  });

  meetValidate = flow(function* (id) {
    try {
      const { resultCode, data } = yield Serv.meetValidate(id);

      if (resultCode === '0') {
        return data;
      }
    } catch (error) {}
  });

  // 获取是否显示肽素乳畅享卡
  getShowBatchOrder = flow(function* (id) {
    try {
      const { resultCode, data } = yield Serv.getShowBatchOrder(id);

      if (resultCode === '0') {
        return data;
      }
    } catch (error) {}
  });

  logout = flow(function* (id) {
    try {
      const { resultCode, data } = yield Serv.logout();

      return data;
    } catch (error) {
      console.log('err', error);
    }
  });

  /**
   * 校验是否需要代客升级
   *
   * @memberof AgentRegisterMod
   */
  confirmUpdate = ({ cardCode, registerTime, phone, password, goNextFun, domId }) => {
    const domVal = window.document.getElementById(domId);
    _reactDom.render(
      <Flex className="checkOrder-activity-tip-modal" justify="center" align="center">
        <Flex
          direction="column"
          justify="between"
          align="center"
          className="register-succ-box-upgrade checkOrder-activity-content-modal">
          <span className="iconfont icon-Successful showSuccessIcon" />
          <span className="fz-32 color-dark-grey fw-bold">{'恭喜您升级为会员'}</span>
          <Flex direction="column" justify="center" align="center">
            <span className="text-upgrade-1">您的账号信息如下</span>
            <span className="text-upgrade-2">会员卡号：{cardCode}</span>
            <span className="text-upgrade-2">登录密码: {password}</span>
            <span className="text-upgrade-2">会员姓名: {phone}</span>
            <span className="text-upgrade-2">创建时间: {registerTime}</span>
          </Flex>
          <Flex
            style={{
              marginTop: '50px',
              width: '100%',
              border: '1px solid rgba(0,0,0,.3)'
            }}>
            <Flex
              justify="center"
              align="center"
              style={{ color: '#000', width: '100%', height: '80px' }}
              onClick={() => {
                _reactDom.render(<div />, domVal);
                window.app.router.goBack();
              }}>
              关闭
            </Flex>
            <div
              style={{
                backgroundColor: 'rgba(0,0,0,.3)',
                width: '100%',
                height: '80px',
                width: '1px'
              }}
            />
            <Flex
              justify="center"
              align="center"
              style={{ color: '#000', width: '100%', height: '80px' }}
              onClick={() => {
                goNextFun && goNextFun();
              }}>
              去升级
            </Flex>
          </Flex>
        </Flex>
      </Flex>,
      domVal
    );
  };

  /**
   * @description 跳转续约有礼
   */
  toRenew = () => {
    const idObj = {
      TEST: '1358663331232282657',
      TEST2: '1358663331232282657',
      UAT3: '1359566489607385106',
      UAT5: '1359566489607385106',
      PROD: '1359490725491870806',
      GREEN: '1359490725491870806'
    };
    const c = (idObj && idObj[Config.HOST]) || '1359490725491870806';
    window.app.routerGoTo({
      pathname: `/shop/home/special/${c}`,
      state: {
        inletTitle: `#会员续约礼#-去激活`
      }
    });
  };

  /**
   * 验证生命周期赠券是否可用
   */
  validateUserLifeCoupon = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.validateUserLifeCoupon(params);
      if (resultCode == 0 && data === 0) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  });
  /**
   * 获导入的取物流信息 以前多为 LY KER
   * @param {String} deliveryNo 发货单号
   */
  getLogistics = flow(function* (deliveryNo) {
    if (deliveryNo == 'null') {
      return;
    }
    const { data } = yield Serv.getLogistics(deliveryNo);
    return data;
  });

  getDeliveryList = flow(function* (tradeNo) {
    try {
      const { data } = yield Serv.getDeliveryList(tradeNo);
      const { deliveryInfo, itemInfo } = data || {};
      return deliveryInfo;
    } catch (err) {}
  });
  /**
   * 先获取发货单
   * 根据发货单获订单对应的物流信息
   */
  queryLogistics = flow(function* (deliveryOrderNos) {
    if (!deliveryOrderNos) {
      return [];
    }
    try {
      const { resultCode, data } = yield Serv.queryLogistics(deliveryOrderNos);

      if (resultCode === '0') {
        return data;
      }
    } catch (error) {}
  });
  /**
   * 订单物流跳转
   *  @param {String} tradeNo 订单号
   */
  tradeNoLogisticsJump = flow(function* (tradeNo) {
    Promise.all([this.getLogistics(tradeNo), this.getDeliveryList(tradeNo)]).then(
      ([res1, res2]) => {
        const logisticsList = [];
        // 后管导入的 物流 以前多为LY KER
        for (const logistics of res1) {
          logisticsList.push({
            shippingNo: logistics.no,
            shippingCompany: logistics.shippingCompany,
            isLY: true, // 指的是导入的订单 以前多为LY KER
            tradeNo: tradeNo
          });
        }
        console.log('res2>>>', res2);
        // 订单物流
        this.queryLogistics((res2 || []).map((item) => item.deliveryOrderNo).join(',')).then(
          (resultData) => {
            if (res2) {
              // res2为空时 该接口会查出所有物流
              for (const logistics of resultData) {
                if (logistics && logistics.shippingNos) {
                  for (const shippingNo of logistics.shippingNos) {
                    if (shippingNo) {
                      logisticsList.push({
                        shippingNo,
                        shippingCompany: logistics.shippingCompanyName,
                        type: res2.find((res) => res.deliveryOrderNo === logistics.deliveryOrderNo)
                          .type,
                        deliveryOrderNo: logistics.deliveryOrderNo
                      });
                    }
                  }
                }
              }
            }

            console.log('logisticsList>>>>', logisticsList);

            // 判断跳转
            // 多个物流跳转到物流信息列表
            // 单个物流跳转到物流详情

            // this.props.location.state = {};

            const deliveryOrderNos =
              logisticsList &&
              logisticsList.length > 1 &&
              logisticsList.map((item) => item.deliveryOrderNo).join(',');
            let deliveryOrderNos1 = '';
            if (!deliveryOrderNos) {
              deliveryOrderNos1 =
                res2 && res2.length >= 1 && res2.map((item) => item.deliveryOrderNo).join(',');
            }
            const delivery = (logisticsList && logisticsList.length > 0 && logisticsList[0]) || {};
            if (delivery.isLY) {
              window.app.routerGoTo({
                pathname: `/member/order/logistics`,
                state: { tradeNo: delivery.tradeNo, isLY: true }
              });
              return;
            }
            window.app.routerGoTo({
              pathname: `/member/order/logistics`,
              state: {
                // type: delivery.type || (res2 && res2[0].type) || '',
                deliveryNo: deliveryOrderNos || deliveryOrderNos1 || ''
              }
            });
          }
        );
      }
    );
  });
  getUserInfoReItem = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getUserInfoReItem();
      if (resultCode === '0') {
        this.recommendItemShow = data;
        return data;
      }
    } catch (error) {
      console.log('getUserInfoReItem', error);
    }
  });

  afterSalePrecheck = flow(function* (params, callback) {
    try {
      const { resultCode, resultMsg } = yield Serv.afterSalePrecheck(params);
      if (+resultCode === 0) {
        callback && callback();
      } else {
        Modal.alert('温馨提示', resultMsg);
      }
    } catch (error) {
      return false;
    }
  });

  queryHeadMsgForPull = flow(function* (params) {
    try {
      const { resultCode, resultMsg, data } = yield Serv.queryHeadMsgForPull(params);
      console.log('data-message', data);
      if (+resultCode === 0 && data) {
        return data;
      } else {
        return {};
      }
    } catch (error) {
      return {};
    }
  });

  /**
   * 修改消息状态为已读
   */
  alterMsgStatus = flow(function* (data, type) {
    try {
      if (!data.id) return;
      yield Serv.alterMsgStatus({ idList: [data.id] });
      if (data.eventId) {
        Serv.updateCheckTime({ taskId: data.eventId });
      }
      // 修改成功，遍历本地列表，将其状态修改为已读
      // let obj = toJS(this[type]);
      // obj.list = obj.list.map(_item => {
      //   if (_item.id == data.id) _item.status = 1;
      //   return _item;
      // });
      // this[type] = obj;
    } catch (err) {
      console.log('err', err);
    }
  });

  // 长链接转短链接
  longUrlByShortUrl = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.longUrlByShortUrl(params);
      if (+resultCode === 0 && data) {
        return data;
      } else {
        return false;
      }
    } catch (err) {
      console.log('err', err);
    }
  });
  /**
   * 查询云健康白名单
   */
  getHealthShowStatus = flow(function* (data, type) {
    try {
      const { resultCode, resultMsg, data } = yield Serv.getHealthShowStatus();
      console.log('data-message', data);
      if (+resultCode === 0 && data) {
        this.healthShowStatus = data || false;
        return data;
      } else {
        return false;
      }
    } catch (err) {
      console.log('err', err);
    }
  });

  useSchoolChangeServ = flow(function* (couponId) {
    try {
      const resultObj = yield Serv.useSchoolChange(couponId);
      const { data, resultMsg } = resultObj || {};
      if (resultMsg == 0) {
        Toast.info('兑换成功！');
      }
      return resultObj;
    } catch (error) {}
  });

  // 消息点击事件
  handleMessageAction = flow(function* (data = {}) {
    const { linkWay, linkContent, ext, status } = data;
    if (status == 0) yield this.alterMsgStatus(data, '');
    switch (Number(linkWay)) {
      case 1: // 跳转到自定义链接
        window.location.href = linkContent;
        break;
      case 2: // 跳转到产品详情
        window.app.routerGoTo(`/shop/productDetail/${linkContent}`);
        break;
      case 3: // 根据id列表跳转到产品列表
        window.app.routerGoTo({
          pathname: '/shop/productList',
          state: {
            frontDirIdList: [linkContent]
          }
        });
        break;
      case 4: // 跳转到文章详情
        window.app.routerGoTo(`/shop/home/news/${linkContent}`);
        break;
      case 5: //促销活动
        window.app.routerGoTo(`/shop/home/activity/normal/${linkContent}`);
        break;
      case 6: //促销主题
        window.app.routerGoTo(`/shop/home/activity/theme/${linkContent}`);
        break;
      case 7: //专题页
        let url =
          ext == 1
            ? `/shop/home/specialProduct/${linkContent}`
            : ext == 4
              ? `/shop/home/special/${linkContent}`
              : `/shop/home/specialClassify/${linkContent}`;

        // 九月开卡活动
        if (linkContent === '1284572010394067054') {
          url = '/shop/home/landingPage';
        }

        window.app.routerGoTo(url);
        break;
      case 8: //资格购
        if (linkContent == 'all') {
          window.app.routerGoTo(`/shop/qualificationPage?showFlag=${true}`);
          return;
        }
        // 资格购跳转
        // this.stores.getQualificationList().then(qualificationList => {
        //   const qualification = qualificationList.find(
        //     item => item.id == linkContent,
        //   );
        //   if (!qualification) {
        //     Toast.info('您没有当前活动资格');
        //     return;
        //   }
        window.app.routerGoTo(`/shop/qualification?id=${linkContent}&showFlag=${true}`);
        // });
        break;
      case 9: //订单详情
        window.app.routerGoTo(`/member/order/detail/${linkContent}`);
        break;
      case 10: //素材详情
        window.app.routerGoTo(`/promote/materialCenter/materialDetail?id=${linkContent}`);
        break;
      case 11: //课程详情
        window.app.routerGoTo('/learn/course/detail?id=' + linkContent);
        break;
      case 13: //物流详情
        this.getDeliveryList(linkContent).then((deliveryList) => {
          if (deliveryList && deliveryList.length === 1) {
            const delivery = deliveryList[0];
            window.app.routerRedirect({
              pathname: `/member/order/logistics`,
              state: { type: delivery.type, deliveryNo: delivery.deliveryOrderNo }
            });
          } else {
            window.app.routerRedirect({
              pathname: `/member/order/delivery`,
              state: { tradeNo: linkContent }
            });
          }
        });
        break;
      case 14: //售后详情
        window.app.routerGoTo(`/member/afterSale/detail?afterSaleNo=${linkContent}`);
        break;
      case 15: //开卡
        if (!this.token) {
          window.app.routerGoTo('/login');
          return;
        }
        if (this.userInfo.userType > 1) {
          Toast.info('您已是会员');
          return;
        }
        this.stores.queryCanApplyType();
        break;
      case 16: //优惠券
        window.app.routerGoTo('/member/wallet/coupon');
        break;
      case 17: //我的权益
        window.app.routerGoTo('/promote/equity');
        break;
      case 18: //素材中心
        window.app.routerGoTo('/promote/materialCenter');
        break;
      case 19: //培训中心
        window.app.routerGoTo('/learn/college');
        break;
      case 20: //新手教程
        window.app.routerGoTo('/personal/noviceCourseList');
        break;
      case 22: // 甄选商城
        window.app.routerGoTo({
          pathname: '/personal/SelectMallHomeView'
        });
        break;
      case 23: // 优惠券w使用
        window.app.routerGoTo({
          pathname: '/member/wallet/coupon',
          state: { couponTemplateId: linkContent }
        });
        break;
      case 25: // 享包邮订单
        window.app.routerGoTo({
          pathname: '/freeShipping',
          search: Util.encodeQuery({
            freeShippingNo: linkContent
          })
        });
        break;
    }
  });

  getInternationalConfig = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getInternationalConfig();
      if (resultCode === '0') {
        this.internationalConfig = data;
      }
    } catch (error) {
      console.log('error', error);
    }
  });

  /**
   * 领取优惠券
   */
  claimCoupon = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.claimCoupon(params);
      if (resultCode === '0') {
        return data;
      }
    } catch (error) {
      console.log('error', error);
    }
  });

  getCouponList = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.getCouponList(params);
      if (resultCode === '0') {
        return data;
      }
    } catch (error) {
      console.log('error', error);
    }
  });
}

const appMod = new AppMod();
export default appMod;



// WEBPACK FOOTER //
// ./src/widget/App/AppMod.js